import styled from 'styled-components';
import { black } from 'utils/style/colors';

type MenuWrapperProps = {
  width: number;
};

export const MenuWrapper = styled('div')<MenuWrapperProps>`
  display: flex;
  margin: 0;
  overflow-y: auto;
  ${(props) => `width: ${props.width}px`};
`;

export const Menu = styled('ul')`
  background-color: var(--exact-white);
  display: block;
  left: 0;
  list-style-type: none;
  margin: 0;
  max-height: 650px;
  width: 100%;
  z-index: 99999;
  padding: 0;
`;

export const MenuDivider = styled('li')`
  background-color: #e0e0e0;
  clear: both;
  height: 1px;
  min-height: 0;
  overflow: hidden;
  width: 100%;
`;

export const MenuItem = styled('li')`
  font-size: 1rem;
  text-align: ${(props) => props.theme.textAlign};
  text-transform: none;
  width: 100%;
  & > a,
  & > span {
    color: ${black};
    background: var(--exact-white);
    overflow: hidden;
    cursor: pointer;
    display: block;
    font-size: 1rem;
    line-height: 1.375rem;
    padding: 0.8765rem 1rem;
    transition: all 0.3s;
    &:hover {
      background-color: rgba(200, 200, 200, 1);
    }
  }
`;
